<div class="page-main-header" [class.open]="open">
    <div class="main-header-right row">
        <div class="mobile-sidebar col">
            <div class="media-body switch-sm">
                <label class="switch">
                    <a>
                        <app-feather-icons id="sidebar-toggle" [icon]="'align-left'" (click)="collapseSidebar()">
                        </app-feather-icons>
                    </a>
                </label>
            </div>
        </div>
        <div class="main-header-left d-lg-none col">
            <div class="logo-wrapper"><a [routerLink]="'/dashboard/default'"> <img class="blur-up lazyloaded img-90"
                        style="width: 52px !important; height: 52px !important;" [src]="logoUrl"
                        (error)="onLogoError($event)" alt="Logo" /></a>
            </div>
        </div>

        <div class="nav-right col">
            <ul class="nav-menus" [ngClass]="{'open' : openNav}">
                <li>
                    <a href="javascript:void(0)" class="text-dark" toggleFullscreen>
                        <app-feather-icons [icon]="'maximize-2'"></app-feather-icons>
                    </a>
                </li>

                <!-- Opcion de notificaciones-->
                <li class="onhover-dropdown">
                    <span
                        class="badge badge-pill badge-primary pull-right notification-badge">{{this.countNotification}}</span>
                    <app-feather-icons [icon]="'bell'"></app-feather-icons><span class="dot"></span>

                    <div>
                        <ul class="notification-dropdown onhover-show-div">
                            <li>Notificaciones
                                <span class="pull-right">
                                    <button *ngIf="countNotification > 0 " class="btn btn-default"
                                        (click)="deleteAllNotifications('notificacion')">
                                        <i class="fa fa-trash" style="color: #ef4444;"></i>
                                    </button>
                                </span>
                            </li>
                            <div style="overflow-y: scroll; height: 40vh; width: 100%;">
                                <li *ngFor="let noti of notificacion;let i = index ">
                                    <div class="media" style="display: flex; justify-content: center;
                                    align-items: start;">


                                        <div class="media-body">
                                            <h6 class="mt-0"><span>
                                                    <app-feather-icons class="shopping-color" [icon]="'message-square'">
                                                    </app-feather-icons>
                                                </span>Firma...
                                            </h6>
                                           
                                            <a href="{{noti.url}}"
                                                (click)="deleteNotification(noti, i)">{{noti.message}}</a>
                                        </div>
                                        <button class="btn btn-default" (click)="deleteNotification(noti, i)">
                                            <i style="font-size: 1.2em; cursor: pointer;" class="fa fa-times"></i>
                                        </button>
                                    </div>
                                </li>
                                <li *ngIf="countNotification === 0">
                                    <div class="media" style="display: flex; justify-content: center;
                                    align-items: start;">
                                        <div class="media-body">
                                            <h6 class="mt-0">
                                                <span>No tienes notificaciones!</span>
                                            </h6>
                                        </div>
                                    </div>
                                </li>

                            </div>
                        </ul>

                    </div>

                </li>

                <li class="onhover-dropdown">
                    <span
                        class="badge badge-pill badge-primary pull-right notification-badge alert">{{this.countAlert}}</span>
                    <app-feather-icons [icon]="'alert-triangle'"></app-feather-icons><span class="dot"></span>

                    <div>
                        <ul class="notification-dropdown onhover-show-div">
                            <li>Alertas
                                <span class="pull-right">
                                    <button *ngIf="countAlert > 0 " class="btn btn-default"
                                        (click)="deleteAllNotifications('alerta')">
                                        <i class="fa fa-trash" style="color: #ef4444;"></i>
                                    </button>
                                </span>
                            </li>
                            <div style="overflow-y: scroll; height: 40vh; width: 100%;">
                                <li *ngFor="let alert of alerta;let i = index ">
                                    <div class="media" style="display: flex; justify-content: center;
                                    align-items: start;">


                                        <div class="media-body">
                                            <h6 class="mt-0"><span>
                                                    <app-feather-icons class="shopping-color" [icon]="'alert-triangle'">
                                                    </app-feather-icons>
                                                </span>Alertas...
                                            </h6>
                                            <a href="{{alert.url}}"
                                                (click)="deleteNotification(alert, i)">{{alert.message}}</a>
                                        </div>
                                        <button class="btn btn-default" (click)="deleteNotification(alert, i)">
                                            <i style="font-size: 1.2em; cursor: pointer;" class="fa fa-times"></i>
                                        </button>
                                    </div>
                                </li>
                                <li *ngIf="countNotification === 0">
                                    <div class="media" style="display: flex; justify-content: center;
                                    align-items: start;">
                                        <div class="media-body">
                                            <h6 class="mt-0">
                                                <span>No tienes alertas!</span>
                                            </h6>
                                        </div>
                                    </div>
                                </li>

                            </div>
                        </ul>

                    </div>

                </li>

                <li class="onhover-dropdown logout-item">
                    <a class="media align-items-center logout-link" (click)="logout()">
                        <app-feather-icons [icon]="'log-out'"></app-feather-icons>
                        <span style="margin-top: 16%;">Salir</span>
                    </a>
                </li>
            </ul>
            <div class="d-lg-none mobile-toggle pull-right" (click)="openMobileNav()">
                <app-feather-icons [icon]="'more-horizontal'"></app-feather-icons>
            </div>
        </div>
    </div>
</div>